var _g, _path, _path2, _path3, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 249,
    viewBox: "0 0 248 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8_741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.384 126.137C124.583 136.596 122.285 148.683 124 160.123C135.154 157.047 145.269 150.039 152.071 139.58C158.872 129.121 161.17 117.034 159.455 105.594C148.301 108.67 138.185 115.678 131.384 126.137Z",
    fill: "url(#paint0_linear_8_741)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.616 126.137C123.417 136.596 125.715 148.683 124 160.123C112.846 157.047 102.73 150.039 95.9292 139.58C89.128 129.121 86.8301 117.028 88.5449 105.588C99.6993 108.664 109.814 115.672 116.616 126.131V126.137Z",
    fill: "url(#paint1_linear_8_741)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.334 124.03C110.334 137.854 115.501 150.467 124 160.06C132.499 150.467 137.666 137.854 137.666 124.03C137.666 110.206 132.499 97.5934 124 88C115.501 97.5934 110.334 110.206 110.334 124.03Z",
    fill: "url(#paint2_linear_8_741)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.384 126.137C124.583 136.596 122.285 148.683 124 160.123C135.154 157.047 145.269 150.039 152.071 139.58C158.872 129.121 161.17 117.034 159.455 105.594C148.301 108.67 138.185 115.678 131.384 126.137Z",
    fill: "url(#paint3_linear_8_741)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.616 126.137C123.417 136.596 125.715 148.683 124 160.123C112.846 157.047 102.73 150.039 95.9292 139.58C89.128 129.121 86.8301 117.028 88.5449 105.588C99.6993 108.664 109.814 115.672 116.616 126.131V126.137Z",
    fill: "url(#paint4_linear_8_741)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.334 124.03C110.334 137.854 115.501 150.467 124 160.06C132.499 150.467 137.666 137.854 137.666 124.03C137.666 110.206 132.499 97.5934 124 88C115.501 97.5934 110.334 110.206 110.334 124.03Z",
    fill: "url(#paint5_linear_8_741)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_8_741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.072 184.057H110.516C107.777 184.057 105.347 182.295 104.492 179.687L94.8718 150.373C93.5221 146.263 96.5775 142.032 100.896 142.032H147.692C152.011 142.032 155.066 146.263 153.717 150.373L144.097 179.687C143.241 182.295 140.812 184.057 138.072 184.057Z",
    fill: "url(#paint6_linear_8_741)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8219 150.062L95.8219 150.062C94.6837 146.595 97.2612 143.032 100.896 143.032H147.692C151.327 143.032 153.905 146.595 152.766 150.062L152.766 150.062L143.147 179.375L144.097 179.687L143.147 179.375C142.425 181.574 140.378 183.057 138.072 183.057H110.516C108.21 183.057 106.163 181.574 105.442 179.375L104.492 179.687L105.442 179.375L95.8219 150.062Z",
    stroke: "url(#paint7_linear_8_741)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8_741",
    x: 0,
    y: 0,
    width: 248,
    height: 248.123,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 44,
    result: "effect1_foregroundBlur_8_741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_8_741",
    x: 76.5493,
    y: 124.032,
    width: 95.4897,
    height: 78.0248,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8_741"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8_741",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_741",
    x1: 158.681,
    y1: 108.561,
    x2: 125.846,
    y2: 155.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#198E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8_741",
    x1: 92.2399,
    y1: 113.9,
    x2: 123.281,
    y2: 155.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#198E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8_741",
    x1: 124.387,
    y1: 99.2731,
    x2: 123.492,
    y2: 156.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85FFB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30FF80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8_741",
    x1: 158.681,
    y1: 108.561,
    x2: 125.846,
    y2: 155.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#198E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8_741",
    x1: 92.2399,
    y1: 113.9,
    x2: 123.281,
    y2: 155.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21D898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#198E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8_741",
    x1: 124.387,
    y1: 99.2731,
    x2: 123.492,
    y2: 156.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85FFB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30FF80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8_741",
    x1: 97.9079,
    y1: 181.684,
    x2: 133.044,
    y2: 131.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8_741",
    x1: 98.7486,
    y1: 145.337,
    x2: 131.134,
    y2: 194.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant);
export default __webpack_public_path__ + "static/media/plant.c766dbafe8159514609474e8145d3a26.svg";
export { ForwardRef as ReactComponent };